import * as React from 'react';
import { createContainer } from 'unstated-next';
function useProgressiveAssetController() {
    const [hasLoaded, setHasLoaded] = React.useState(false);
    function completeLoading() {
        setHasLoaded(true);
    }
    return {
        completeLoading,
        hasLoaded,
    };
}
export const ProgressiveAssetController = createContainer(useProgressiveAssetController);
//# sourceMappingURL=ProgressiveAssetController.js.map